import {Variable} from '../../models/variable';
import {AssessmentResult} from '../../../shared/models/assessment-result';
import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';
import { Assessment } from 'app/shared/models/assessment';
import { ScaleResult } from 'app/shared/models/scale-result';
import { ReportNavigatorService } from 'app/reports/services/report-navigator.service';
import { Scale } from 'app/shared/models/scale';
import { Question } from 'app/shared/models/question';


interface ActionsByScale {
  [scaleId: string] : {scale:Scale, question:Question, action:string, label: string, data:any}[]
}
@Component({
  selector: 'app-therapist-scale-results',
  templateUrl: './therapist-scale-results.component.html'
})
export class TherapistScaleResultsComponent extends ScaleDataSectionComponent implements OnInit, OnDestroy  {
  
  // TODO: stephen is it good to have this as a dynamic report item and as a 
  // usable component??? seems to mix the uses and causes ugly hacks in ngOnInit.
  @Input() expandContent:boolean;
  @Input("scalesPerPage") externalScalesPerPage:number;
  @Input("scaleResults") externalScaleResults:ScaleResult[];
  @Input("assessmentResult") externalAssessmentResult:AssessmentResult;
  @Input("resultTitle") externalTitle:string;
  private _scales_per_page:number;
  private _title:string;
  private _skipGraph:boolean;
  private _skipContent:boolean;
  private _skipTable:boolean;
  private _showRangeScore:boolean;
  private _questionActionsByScale:ActionsByScale;
  private _rollUpQuestions:boolean;

  private _questionActions:any[];
  
  

  constructor(private navigator:ReportNavigatorService, private el:ElementRef) {
    super();
    this._skipContent = false;
    this._skipGraph = false;
    this._skipTable = false;
    this._showRangeScore = true;
    this._rollUpQuestions = false;
  }

  ngOnInit() {
    // coming from the decorator.
    // assign all the data that comes from the navigator.
    if (this.externalScalesPerPage) {
      this._scales_per_page = this.externalScalesPerPage;
    }
    if (this.externalScaleResults) {
      this.ScaleResults.push(...this.externalScaleResults);
    }
    if (this.externalAssessmentResult) {
      this.AssessmentResult = this.externalAssessmentResult;
    }
    if (this.externalTitle) {
      this._title = this.externalTitle;
    }
  }
  ngAfterViewInit() {
    if (this.ScaleResults) {
      this.populateNavigator(this.ScaleResults);
    }
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    this.cleanupNavigator();
  }

  public getLegendLabels(scaleResult:ScaleResult) {
    return scaleResult.scale.ranges.map(r => r.displayName);
  }

  getTitle() {
    return this._title;
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    super.setReportData(data, results, variables);
    
    if (data && data.hasOwnProperty('expandContent') && data.expandContent === false) {
      this.expandContent = false;
    }

    if (data && data.title) {
      this._title = data.title;
    }
    else {
      this._title = this.Assessment.name;
    }
    
    if (data && data.scales_per_page) {
      this._scales_per_page = +data.scales_per_page;
    }
    else if (this.ScaleResults) {
      // this makes it so we never force a page break here.
      this._scales_per_page = this.ScaleResults.length + 1;
    }
    else {
      console.error("No scales found for component");
      this._scales_per_page = 0;
    }
    if (data) {
      this._skipTable = data.skipTable == true;
      this._skipGraph = data.skipGraph == true;
      this._skipContent = data.skipContent == true;
      // default is to show them... so we want to check for false instead of true.
      // so that old reports always shows the score range...
      this._showRangeScore = data.showRangeScore !== false; 
      this._rollUpQuestions = data.rollUpQuestions == true;

      if (data.hasTableAction) {
        let questionById = this.Assessment.getQuestionsListById();
        this._questionActions = (data.tableActions || []).map(ta => {
          let question = questionById[ta.questionId] || {};
          return {
            scale: question.scale
            ,question: question
            ,action: ta.action
            ,label: data.tableActionLabel
            ,data: ta.data
          };
        });
        // this._questionActionsByScale = {};
        // (data.tableActions || []).forEach(ta => {
        //   
        //   let scaleResult = this.ScaleResults.find(sr => sr.scale.id == ta.scaleId);
        //   if (!scaleResult) {
        //     console.error("Could not find scale result with scale id ", ta.scaleId);
        //   } else if (!this._questionActionsByScale[scaleResult.scale.id]) {
        //     this._questionActionsByScale[scaleResult.scale.id] = [];
        //   }
        //   let action = {
        //     scale: scaleResult.scale
        //     ,question: questions[ta.questionId]
        //     ,action: ta.action
        //     ,label: data.tableActionLabel
        //     ,data: ta.data
        //   };
        //   this._questionActionsByScale[ta.scaleId].push(action);
        // })
      }
    }
  }

  public shouldShowQuestionList(scaleResult) {
    if (this.SkipTable) {
      return false;
    }
    if (this.hasSubScales(scaleResult)  && !this.shouldRollUpQuestions(scaleResult)) {
      return false;
    }
   return true;
  }

  public shouldRollUpQuestions(scaleResult:ScaleResult) {
    if (this.RollUpQuestions) {
      return true;
    }
    return scaleResult && scaleResult.scale && scaleResult.scale.rollUpSubScales === true;
  }

  public shouldShowSubScalesList(scaleResult) {
    if (this.SkipTable) {
      return false;
    }
    if (this.hasSubScales(scaleResult)) {
      if (!this.shouldRollUpQuestions(scaleResult)) {
        return true;
      }
    }

    return false;
  }

  private getQuestionsForScaleResult(scaleResult, depth = 0) {
    let questionList = [];
    if (depth > 50) {
      console.error("Max recursive depth reached");
      return questionList;
    }
    if (this.hasSubScales(scaleResult)) {
      let subScaleResults = this.getSubScales(scaleResult);
      questionList = subScaleResults.map(sr => this.getQuestionsForScaleResult(sr, depth + 1))
                    .reduce((prev, curr) => prev.concat(curr), []);
    }
    else {
      questionList = this.Assessment.getQuestionsForScale(scaleResult.scale);
    }
    return questionList;
  }

  public getActionByScale(scale) {
    return this._questionActions; // for now we just return everything
    // return this._questionActionsByScale[scale.id];
  }

  private populateNavigator(scaleResults:ScaleResult[]) {
    scaleResults.forEach(sr => {
      let rootElement = this.el.nativeElement as HTMLElement;
      let element = rootElement.querySelector("#" + this.getScaleResultNavigatorId(sr));
      if (element) {
        this.navigator.registerItem(sr.scale.id, element);
      }
    });
  }

  public getScaleResultNavigatorId(scaleResult:ScaleResult) {
    return "id-" + scaleResult.scale.id;
  }

  private cleanupNavigator() {
    this.ScaleResults.forEach(sr => {
      this.navigator.unregisterItem(sr.scale.id);
    });
  }

  public shouldPrintBreak(index:number) {
    // since index is 0 based the the user scales per page is 1 based we convert.
    return ((index + 1) % this._scales_per_page == 0);
  }

  public shouldReverseScaleGraph(scaleResult:ScaleResult) {
    return scaleResult && scaleResult.scale && scaleResult.scale.negativeToPositiveRanges;
  }

  get ScalesPerPage() {
    return this._scales_per_page;
  }

  get Assessment() : Assessment {
    if (this.AssessmentResult) {
      return this.AssessmentResult.assessment;
    }
    return null;
  }

  get SkipContent() : boolean {
    return this._skipContent;
  }

  get SkipGraph() : boolean {
    return this._skipGraph;
  }

  get SkipTable() : boolean {
    return this._skipTable;
  }

  get ShowRangeScore() : boolean {
    return this._showRangeScore;
  }

  get RollUpQuestions() : boolean {
    return this._rollUpQuestions;
  }

  public hasSubScales(scaleResult:ScaleResult) {
    return scaleResult && scaleResult.scale && scaleResult.scale.hasSubScales();
  }
  public getSubScales(scaleResult:ScaleResult) {
    if (scaleResult.scale.hasSubScales()) {
      return scaleResult.scale.getSubScaleIds().map(si => this.AssessmentResult.getScaleResultByScaleId(si));
    }
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/therapist-scale-results/therapist-scale-results.component.ts